module.exports = __webpack_public_path__ + "img/home_menu_5_default.24a3d5d9.png";